import type { SupabaseClient } from '@supabase/supabase-js';
import { supabaseConfiguration } from '../config/supabase';
import type { SupabaseDatabase } from '../domain/supabase/database.types';
import type { InviteCodeHash } from '../utils/inviteCode';

export interface InviteAccessService {
  isAvailable(inviteHash: InviteCodeHash): Promise<boolean>;
}

export class InviteAccessServiceError extends Error {
  constructor(message: string, readonly cause?: unknown) {
    super(message);
    this.name = 'InviteAccessServiceError';
  }
}

export const createInviteAccessService = (
  client: SupabaseClient<SupabaseDatabase> | null,
  configurationMessage = client ? 'Supabase configurado.' : 'Configuração do Supabase pendente neste ambiente.'
): InviteAccessService => ({
  async isAvailable(inviteHash) {
    if (!client) throw new InviteAccessServiceError(configurationMessage);
    try {
      const { data, error } = await client.rpc('is_invite_available', { invite_hash: inviteHash });
      if (error) throw error;
      return data === true;
    } catch (error) {
      if (error instanceof InviteAccessServiceError) throw error;
      throw new InviteAccessServiceError(
        error instanceof TypeError
          ? 'Não foi possível verificar o convite. Confira sua conexão e tente novamente.'
          : 'Não foi possível verificar este convite agora. Tente novamente.',
        error
      );
    }
  }
});

export const inviteAccessService = createInviteAccessService(
  supabaseConfiguration.client,
  supabaseConfiguration.message
);
